import React, { useState, useEffect } from "react";
import "./ManageTickectsView.css";

const API_URL = process.env.REACT_APP_API_URL;

export default function ManageTickectsView() {
  const [ganadores, setGanadores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sorteoActual, setSorteoActual] = useState(null);

  const token = localStorage.getItem("access_token");

  const fetchSorteoActual = async () => {
    try {
      const res = await fetch(`${API_URL}/info_sorteo_actual`);
      if (res.ok) {
        const data = await res.json();
        setSorteoActual(data);
        return data;
      }
    } catch (err) {
      console.error("Error fetching sorteos:", err);
    }
    return null;
  };

  const fetchGanadores = async (sorteoData) => {
    if (
      !sorteoData?.patronId ||
      !sorteoData?.nombreSorteo ||
      !sorteoData?.fechaSorteo
    ) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(
        `${API_URL}/historial_ganadores?nombreSorteo=${encodeURIComponent(sorteoData.nombreSorteo)}&fechaSorteo=${encodeURIComponent(sorteoData.fechaSorteo)}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.ok) {
        const data = await res.json();
        const historial = data.ganadores || [];

        const winnersWithEmail = await Promise.all(
          historial.map(async (winner) => {
            const ticketRes = await fetch(
              `${API_URL}/tickets/${winner.serie}`,
              { headers: { Authorization: `Bearer ${token}` } },
            );

            let email = "Sin correo";
            if (ticketRes.ok) {
              const ticketData = await ticketRes.json();
              email = ticketData.email || "Sin correo";
            }

            return {
              serie: winner.serie,
              qr_code: winner.qr_code,
              nombreSorteo: winner.nombreSorteo,
              fechaSorteo: winner.fechaSorteo,
              email,
            };
          }),
        );

        setGanadores(winnersWithEmail);
      } else {
        throw new Error("Error al cargar ganadores");
      }
    } catch (err) {
      setError(err.message);
      setGanadores([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      const sorteos = await fetchSorteoActual();
      if (sorteos) {
        await fetchGanadores(sorteos);
      } else {
        setLoading(false);
      }
    };
    init();
  }, []);

  const getQrCodeDisplay = (qrCode) => {
    if (!qrCode) return "-";
    if (qrCode.length > 20) {
      return `${qrCode.substring(0, 10)}...${qrCode.substring(qrCode.length - 10)}`;
    }
    return qrCode;
  };

  return (
    <div className="manage-tickets-container">
      <div className="tickets-header">
        <div className="jugadores-sala">
          <span className="jugadores-icon">👥</span>
          <span className="jugadores-label">Jugadores en sala:</span>
          <span className="jugadores-numero">{sorteoActual?.numeroJugadores || 0}</span>
          <button
            className="refresh-jugadores-btn"
            onClick={fetchSorteoActual}
            title="Actualizar jugadores"
          >
            🔄
          </button>
        </div>
        <h2 className="tickets-titulo">🎫 Tickets Ganadores</h2>
        <div className="sorteo-info">
          {sorteoActual ? (
            <div className="sorteo-detalles">
              <span className="sorteo-name">{sorteoActual.nombreSorteo}</span>
              <span className="sorteo-fecha">{sorteoActual.fechaSorteo}</span>
            </div>
          ) : (
            <span className="no-sorteo">No hay sorteo activo</span>
          )}
        </div>
      </div>

      {loading ? (
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Cargando ganadores...</p>
        </div>
      ) : error ? (
        <div className="error-state">
          <p>⚠️ {error}</p>
        </div>
      ) : (
        <div className="tickets-list-container">
          {ganadores.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🏆</div>
              <p>No hay ganadores aún</p>
              <span>
                Los tickets winners aparecerán aquí cuando se detecte un ganador
              </span>
            </div>
          ) : (
            <>
              <div className="tickets-count">
                <span className="count-badge">{ganadores.length}</span>
                <span>
                  ganador{ganadores.length !== 1 ? "es" : ""} detectado
                  {ganadores.length !== 1 ? "s" : ""}
                </span>
              </div>
              <div className="tickets-table">
                <div className="table-header">
                  <div className="col email">Correo</div>
                  <div className="col ticket">Cartón (QR)</div>
                  <div className="col serie">Serie</div>
                  <div className="col sorteo">Sorteo</div>
                  <div className="col fecha">Fecha</div>
                </div>
                <div className="table-body">
                  {ganadores.map((winner, idx) => (
                    <div key={idx} className="table-row">
                      <div className="col email">
                        <span className="email-text">{winner.email}</span>
                      </div>
                      <div className="col ticket">
                        <span className="qr-code" title={winner.qr_code}>
                          {getQrCodeDisplay(winner.qr_code)}
                        </span>
                      </div>
                      <div className="col serie">
                        <span className="serie-badge">{winner.serie}</span>
                      </div>
                      <div className="col sorteo">
                        <span className="sorteo-name">
                          {winner.nombreSorteo}
                        </span>
                      </div>
                      <div className="col fecha">
                        <span className="fecha-text">{winner.fechaSorteo}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
